export const messagesMonitoring = {
    pt: {
        message:{
            advertiserNoActiveCampaign: "Anunciante sem campanha ativa",
            autoClosed: "Resolvido Automaticamente",
            campaign: "Campanhas",
            campaigns: "Campanhas",
            closed: "Resolvido",
            date: "Data",
            estabNoActiveCampaign: "Estabelecimento sem campanha ativa",
            noAccesses: "Sem acessos",
            noActiveCampaign: "Sem campanha ativa",
            open: "Aberto",
            origin: "Origem",
            resolving: "Resolvendo",
            type: "Tipo",
            types: "Tipos"

        }
    },
    es: {
        message:{
            advertiserNoActiveCampaign:"Anunciante sin campaña activa",
            autoClosed:"Resuelto automáticamente",
            campaign:"Campañas",
            campaigns:"Campañas",
            closed:"Resuelto",
            date:"Fecha",
            estabNoActiveCampaign:"Establecimiento sin campaña activa",
            noAccesses:"Sin acceso",
            noActiveCampaign:"Sin campaña activa",
            open:"Abierto",
            origin:"Origen",
            resolving:"Resolviendo",
            type:"Tipo",
            types:"Tipos"
        }
    },
    en: {
        message:{
            advertiserNoActiveCampaign: "Advertiser without active campaign",
            autoClosed: "Auto closed",
            campaign: "Campaign",
            campaigns: "Campaigns",
            closed: "Closed",
            date: "Date",
            estabNoActiveCampaign: "Establishment without active campaign",
            noAccesses: "No accesses",
            noActiveCampaign: "No active campaign ",
            open: "Open",
            origin: "Origin",
            resolving: "Resolving",
            type: "Type",
            types: "Types"

        }
    }
}
